import { CalculatePolygonArea } from './CalculatePolygonArea';
import { CalculatePolygonPerimeter } from './CalculatePolygonPerimeter';

export function AddArc(
  coordinates,
  entities,
  power,
  activeDetailIndex,
  suppress,
  suppressArea,
  tagOffset,
  suppressDisplay,
  layerIndex,
) {
  let lockDist = 4;
  let resultArray = entities.slice();
  let newPolygon = [];
  let newArc = [];
  let newAngle = [];
  let newLabel = [];
  let connects = [];
  let detailIndex = 0;
  let startIndex = 0;
  let activeLayerIndex = layerIndex === undefined ? 0 : layerIndex;

  // Find how many times new line connects to existing line endpoints and at what indices
  for (let x = 0; x < entities.length; x++) {
    for (let y = 0; y < entities[x].coordinates.length; y++) {
      if (
        withinDistance(coordinates[0], entities[x].coordinates[y], lockDist) &&
        !isPolygon(entities[x].coordinates) &&
        entities[x].detailInfo === activeDetailIndex &&
        (entities[x].layerIndex === activeLayerIndex ||
          entities[x].layerIndex === undefined)
      ) {
        if (y === 0) {
          //start point is equal to start point of a line
          let id = Math.random();
          newPolygon = [coordinates[1], ...entities[x].coordinates];
          newArc = [
            { type: 'start', power: power ? power : 20, id: id },
            ...entities[x].arcData,
          ];
          newAngle = [true, ...entities[x].angleData];
          newLabel = [
            {
              label: suppress ? true : false,
              display: suppressDisplay ? true : false,
            },
            ...entities[x].suppressLabel.slice(),
          ];
          startIndex = 0;
          detailIndex = x;
          connects.push({
            polygon: newPolygon,
            arc: newArc,
            angle: newAngle,
            label: newLabel,
            index: x,
            orient: 'start',
          });
        } else if (y === entities[x].coordinates.length - 1) {
          // start point is equal to end point of a line
          let id = Math.random();
          newPolygon = [...entities[x].coordinates, coordinates[1]];
          newArc = [
            ...entities[x].arcData.slice(0, entities[x].arcData.length - 1),
            { type: 'start', power: power ? power : 20, id: id },
            false,
          ];
          newAngle = [...entities[x].angleData, true];
          newLabel = [
            ...entities[x].suppressLabel.slice(
              0,
              entities[x].suppressLabel.length - 1,
            ),
            {
              label: suppress ? true : false,
              display: suppressDisplay ? true : false,
            },
            { label: false, display: false },
          ];
          startIndex = entities[x].coordinates.length - 1;
          detailIndex = x;
          connects.push({
            polygon: newPolygon,
            arc: newArc,
            angle: newAngle,
            label: newLabel,
            index: x,
            orient: 'end',
          });
        }
      } else if (
        withinDistance(coordinates[1], entities[x].coordinates[y], lockDist) &&
        !isPolygon(entities[x].coordinates) &&
        entities[x].detailInfo === activeDetailIndex &&
        (entities[x].layerIndex === activeLayerIndex ||
          entities[x].layerIndex === undefined)
      ) {
        if (y === 0) {
          //end point is equal to start point of a line
          let id = Math.random();
          newPolygon = [coordinates[0], ...entities[x].coordinates];
          newArc = [
            { type: 'start', power: power ? power : 20, id: id },
            ...entities[x].arcData,
          ];
          newLabel = [
            {
              label: suppress ? true : false,
              display: suppressDisplay ? true : false,
            },
            ...entities[x].suppressLabel.slice(),
          ];
          newAngle = [true, ...entities[x].angleData];
          startIndex = 0;
          detailIndex = x;
          connects.push({
            polygon: newPolygon,
            arc: newArc,
            angle: newAngle,
            label: newLabel,
            index: x,
            orient: 'start',
          });
        } else if (y === entities[x].coordinates.length - 1) {
          //end point is equal to end point of a line
          let id = Math.random();
          newPolygon = [...entities[x].coordinates, coordinates[0]];
          newArc = [
            ...entities[x].arcData.slice(0, entities[x].arcData.length - 1),
            { type: 'start', power: power ? power : 20, id: id },
            false,
          ];
          newAngle = [...entities[x].angleData, true];
          newLabel = [
            ...entities[x].suppressLabel.slice(
              0,
              entities[x].suppressLabel.length - 1,
            ),
            {
              label: suppress ? true : false,
              display: suppressDisplay ? true : false,
            },
            { label: false, display: false },
          ];
          startIndex = entities[x].coordinates.length - 1;
          detailIndex = x;
          connects.push({
            polygon: newPolygon,
            arc: newArc,
            angle: newAngle,
            label: newLabel,
            index: x,
            orient: 'end',
          });
        }
      }
    }
  }
  //rebuild array
  if (connects.length === 0) {
    // Make new single line

    detailIndex = entities.length;
    let id = Math.random();
    let newEntity = {
      name: 'detail' + resultArray.length,
      coordinates: coordinates,
      perimeter: null,
      area: null,
      type: null,
      angle: 0,
      arcData: [{ type: 'start', power: power ? power : 20, id: id }, false],
      angleData: [true, true],
      suppressLabel: [
        {
          label: suppress ? true : false,
          display: suppressDisplay ? true : false,
        },
        { label: false, display: false },
      ],
      detailInfo: activeDetailIndex,
      tagOffset: [0, 0],
      layerIndex: activeLayerIndex,
    };
    resultArray.push(newEntity);
  } else if (connects.length === 1) {
    // Connect to existing line
    resultArray[connects[0].index].coordinates = connects[0].polygon;
    resultArray[connects[0].index].arcData = connects[0].arc;
    resultArray[connects[0].index].angleData = connects[0].angle;
    resultArray[connects[0].index].suppressLabel = connects[0].label;
  } else if (connects.length === 2) {
    if (connects[0].index === connects[1].index) {
      // Polygon formed
      let points = resultArray[connects[0].index].coordinates.concat([
        resultArray[connects[0].index].coordinates[0],
      ]);
      let newArcData = resultArray[connects[0].index].arcData.concat([
        resultArray[connects[0].index].arcData[0],
      ]);
      let id = Math.random();
      newArcData[newArcData.length - 1] = false;
      newArcData[newArcData.length - 2] = {
        type: 'start',
        power: power ? power : 20,
        id: id,
      };
      let newLabelData = resultArray[connects[0].index].suppressLabel.concat([
        resultArray[connects[0].index].suppressLabel[0],
      ]);
      newLabelData[newLabelData.length - 1] = { label: false, display: false };
      newLabelData[newLabelData.length - 2] = {
        label: suppress ? true : false,
        display: suppressDisplay ? true : false,
      };
      startIndex = newArcData.length - 2;
      detailIndex = connects[0].index;
      let newangleData = resultArray[connects[0].index].angleData.concat([
        resultArray[connects[0].index].angleData[0],
      ]);
      let perimeter = CalculatePolygonPerimeter(
        { coordinates: points, arcData: newArcData, negative: false },
        entities,
        connects[0].index,
      );
      let area = CalculatePolygonArea(
        { coordinates: points, arcData: newArcData, negative: false },
        entities,
        connects[0].index,
      );

      resultArray[connects[0].index] = {
        name: resultArray[connects[0].index].name,
        coordinates: points,
        perimeter: perimeter,
        area: area,
        type: 'detail',
        angle: 0,
        arcData: newArcData,
        angleData: newangleData,
        suppressLabel: newLabelData,
        tagInvisible: suppressArea ? true : false,
        detailInfo: resultArray[connects[0].index].detailInfo,
        tagOffset: tagOffset ? tagOffset : [0, 0],
        layerIndex: activeLayerIndex,
      };
    } else {
      // Connect two separate lines together
      let combineArray;
      if (connects[0].orient === 'start' && connects[1].orient === 'start') {
        let points = resultArray[connects[0].index].coordinates
          .reverse()
          .concat(resultArray[connects[1].index].coordinates);
        let newArcData = arcDataReverse(resultArray[connects[0].index].arcData)
          .reverse()
          .concat(resultArray[connects[1].index].arcData);
        let id = Math.random();
        newArcData[resultArray[connects[0].index].arcData.length - 1] = {
          type: 'start',
          power: power ? power : 20,
          id: id,
        };
        startIndex = resultArray[connects[0].index].arcData.length - 1;
        detailIndex = connects[0].index;
        let newLabelData = resultArray[connects[0].index].suppressLabel
          .reverse()
          .concat(resultArray[connects[1].index].suppressLabel);
        newLabelData[
          resultArray[connects[0].index].suppressLabel.length - 1
        ] = {
          label: suppress ? true : false,
          display: suppressDisplay ? true : false,
        };
        let newangleData = resultArray[connects[0].index].angleData
          .reverse()
          .concat(resultArray[connects[1].index].angleData);
        let perimeter = 0;
        for (let x = 0; x < points.length - 1; x++) {
          perimeter = perimeter + calculateLength(points[x], points[x + 1]);
        }
        combineArray = {
          name: resultArray[connects[0].index].name,
          coordinates: points,
          perimeter: perimeter,
          area: null,
          type: 'detail',
          angle: 0,
          arcData: newArcData,
          angleData: newangleData,
          suppressLabel: newLabelData,
          detailInfo: resultArray[connects[0].index].detailInfo,
          tagOffset: [0, 0],
          layerIndex: activeLayerIndex,
        };
      } else if (connects[0].orient === 'end' && connects[1].orient === 'end') {
        let points = resultArray[connects[0].index].coordinates.concat(
          resultArray[connects[1].index].coordinates.reverse(),
        );
        let newArcData = resultArray[connects[0].index].arcData.concat(
          arcDataReverse(resultArray[connects[1].index].arcData).reverse(),
        );
        let id = Math.random();
        newArcData[resultArray[connects[0].index].arcData.length - 1] = {
          type: 'start',
          power: power ? power : 20,
          id: id,
        };
        startIndex = resultArray[connects[0].index].arcData.length - 1;
        detailIndex = connects[0].index;
        let newLabelData = resultArray[connects[0].index].suppressLabel.concat(
          resultArray[connects[1].index].suppressLabel.reverse(),
        );
        newLabelData[
          resultArray[connects[0].index].suppressLabel.length - 1
        ] = {
          label: suppress ? true : false,
          display: suppressDisplay ? true : false,
        };
        let newangleData = resultArray[connects[0].index].angleData.concat(
          resultArray[connects[1].index].angleData.reverse(),
        );
        let perimeter = 0;
        for (let x = 0; x < points.length - 1; x++) {
          perimeter = perimeter + calculateLength(points[x], points[x + 1]);
        }
        combineArray = {
          name: resultArray[connects[0].index].name,
          coordinates: points,
          perimeter: perimeter,
          area: null,
          type: 'detail',
          angle: 0,
          arcData: newArcData,
          angleData: newangleData,
          suppressLabel: newLabelData,
          detailInfo: resultArray[connects[0].index].detailInfo,
          tagOffset: [0, 0],
          layerIndex: activeLayerIndex,
        };
      } else if (
        connects[0].orient === 'start' &&
        connects[1].orient === 'end'
      ) {
        let points = resultArray[connects[0].index].coordinates
          .reverse()
          .concat(resultArray[connects[1].index].coordinates.reverse());
        let newArcData = arcDataReverse(resultArray[connects[0].index].arcData)
          .reverse()
          .concat(
            arcDataReverse(resultArray[connects[1].index].arcData).reverse(),
          );
        let id = Math.random();
        newArcData[resultArray[connects[0].index].arcData.length - 1] = {
          type: 'start',
          power: power ? power : 20,
          id: id,
        };
        startIndex = resultArray[connects[0].index].arcData.length - 1;
        detailIndex = connects[0].index;
        let newLabelData = resultArray[connects[0].index].suppressLabel
          .reverse()
          .concat(resultArray[connects[1].index].suppressLabel.reverse());
        newLabelData[
          resultArray[connects[0].index].suppressLabel.length - 1
        ] = {
          label: suppress ? true : false,
          display: suppressDisplay ? true : false,
        };
        let newangleData = resultArray[connects[0].index].angleData
          .reverse()
          .concat(resultArray[connects[1].index].angleData.reverse());
        let perimeter = 0;
        for (let x = 0; x < points.length - 1; x++) {
          perimeter = perimeter + calculateLength(points[x], points[x + 1]);
        }
        combineArray = {
          name: resultArray[connects[0].index].name,
          coordinates: points,
          perimeter: perimeter,
          area: null,
          type: 'detail',
          angle: 0,
          arcData: newArcData,
          angleData: newangleData,
          suppressLabel: newLabelData,
          detailInfo: resultArray[connects[0].index].detailInfo,
          tagOffset: [0, 0],
          layerIndex: activeLayerIndex,
        };
      } else if (
        connects[0].orient === 'end' &&
        connects[1].orient === 'start'
      ) {
        let points = resultArray[connects[0].index].coordinates.concat(
          resultArray[connects[1].index].coordinates,
        );
        let newArcData = resultArray[connects[0].index].arcData.concat(
          resultArray[connects[1].index].arcData,
        );
        let id = Math.random();
        newArcData[resultArray[connects[0].index].arcData.length - 1] = {
          type: 'start',
          power: power ? power : 20,
          id: id,
        };
        startIndex = resultArray[connects[0].index].arcData.length - 1;
        detailIndex = connects[0].index;
        let newLabelData = resultArray[connects[0].index].suppressLabel.concat(
          resultArray[connects[1].index].suppressLabel,
        );
        newLabelData[
          resultArray[connects[0].index].suppressLabel.length - 1
        ] = {
          label: suppress ? true : false,
          display: suppressDisplay ? true : false,
        };
        let newangleData = resultArray[connects[0].index].angleData.concat(
          resultArray[connects[1].index].angleData,
        );
        let perimeter = 0;
        for (let x = 0; x < points.length - 1; x++) {
          perimeter = perimeter + calculateLength(points[x], points[x + 1]);
        }
        combineArray = {
          name: resultArray[connects[0].index].name,
          coordinates: points,
          perimeter: perimeter,
          area: null,
          type: 'detail',
          angle: 0,
          arcData: newArcData,
          angleData: newangleData,
          suppressLabel: newLabelData,
          detailInfo: resultArray[connects[0].index].detailInfo,
          tagOffset: [0, 0],
          layerIndex: activeLayerIndex,
        };
      }
      let tempArray = [];
      for (let x = 0; x < resultArray.length; x++) {
        if (x === connects[0].index) {
          tempArray.push(combineArray);
        } else if (x !== connects[0].index && x !== connects[1].index) {
          tempArray.push(resultArray[x]);
        }
      }
      resultArray = tempArray;
    }
  }
  let result = {};
  result.detailIndex = connects[0] ? connects[0].index : detailIndex;
  result.startIndex = startIndex;
  result.data = resultArray;

  return result;
}

function withinDistance(coords, targetPoint, lockDist) {
  return (
    Math.abs(targetPoint[0] - coords[0]) <= lockDist &&
    Math.abs(targetPoint[1] - coords[1]) <= lockDist
  );
}

function isPolygon(coords) {
  if (
    coords.length > 2 &&
    coords[0][0] === coords[coords.length - 1][0] &&
    coords[0][1] === coords[coords.length - 1][1]
  ) {
    return true;
  }
  return false;
}

function calculateLength(start, target) {
  return Math.sqrt(
    Math.pow(Math.abs(start[0] - target[0]), 2) +
      Math.pow(Math.abs(start[1] - target[1]), 2),
  );
}

function arcDataReverse(arcData) {
  let tempArcData = arcData.slice();
  let arcResult = [];
  arcResult[0] = false;
  for (let x = 1; x < arcData.length; x++) {
    if (tempArcData[x - 1]) {
      tempArcData[x - 1].power = -1 * tempArcData[x - 1].power;
    }
    arcResult[x] = tempArcData[x - 1];
  }
  return arcResult;
}

function inPolygon(point, vs) {
  var x = point[0],
    y = point[1];

  var inside = false;
  for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
    var xi = vs[i][0],
      yi = vs[i][1];
    var xj = vs[j][0],
      yj = vs[j][1];

    var intersect =
      yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }

  return inside;
}

function rotatePoint(cx, cy, x, y, angle) {
  var radians = (Math.PI / 180) * angle,
    cos = Math.cos(radians),
    sin = Math.sin(radians),
    nx = cos * (x - cx) + sin * (y - cy) + cx,
    ny = cos * (y - cy) - sin * (x - cx) + cy;
  return [nx, ny];
}
